import { isProspectFindWorkPage, isProspectDashboardPage } from '../pages';
import { tracking, _t } from '@bark/bark-core';
import { getRecaptchaToken } from "@bark/bark-core/src/helpers/reCAPTCHA";

export function initProspectsSignupJs() {

    const redirectStorageKey = 'prospect-rescue-incomplete';

    var errorAnimationTimeout = null;

    var payload = {};

    var userdata = {};

    var redirectTimeouts = [];

    let sellerProfileId;
    let is_lead_unavailable_flow = 0;
    let is_user_rescue_flow = 0;

    function attachEventHandlers() {

        $(".prospect-faq-link").on('click', function (e) {
            $("#prospectFAQModal").modal('show');
            logEvent("click", "prospect faq link");
            e.preventDefault();
            return false;
        });

        $(".lead-detail-link").on('click', function (e) {
            $("#leadDetailModal").modal('show');
            logEvent("click", "lead detail link");
            e.preventDefault();
            return false;
        });

        $(".prospect-signup-form-link").on('click', function (e) {
            $("#prospectSignupFormModal").modal('show');
            logEvent("click", "signup form link");
            tracking('prospect-signup', 'Select free lead - success', {
                project_id: $('#project-id').val(),
                category_id: payload.maincategoryid ?? $('#category-id').val(),
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });
            tracking('prospect-signup', 'Enter details - view', {
                category_id: payload.maincategoryid ?? $('#category-id').val(),
                project_id: $('#project-id').val(),
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });
            e.preventDefault();
            return false;
        });

        $(".prospect-signup-trustpilot a").on('click', function (e) {
            tracking('Prospects - Signup', 'Enter Details New - Click Trustpilot', {
                category_id: payload.maincategoryid ?? $('#category-id').val(),
                country_id: $('#country-id').val(),
                project_id: $('#project-id').val(),
            });
        });

        $('.prospect-profile-form input.form-control').on('keyup', function(e) {
            var t = $(this);
            if (t.val().trim().length > 0) {
                $(t).addClass('not-empty');
            } else {
                $(t).removeClass('not-empty');
            }
        });

        // Track field interactions with Datadog RUM for both signup forms
        if (typeof window.DD_RUM !== 'undefined') {
            const formType = $('.prospect-profile-form-v4').length > 0 ? 'signup-v4' : 'signup-v3';
            const formSelector = $('.prospect-profile-form-v4').length > 0 ? '.prospect-profile-form-v4' : '.prospect-profile-form';

            if ($(formSelector).length > 0) {
                // Track first focus on each field
                $(formSelector + ' input.form-control').one('focus', function() {
                    const fieldId = $(this).attr('id');
                    const fieldName = $(this).attr('name');

                    window.DD_RUM.addAction('signup-field-focus', {
                        formType: formType,
                        fieldId: fieldId,
                        fieldName: fieldName,
                        categoryId: $('#category-id').val(),
                        isRequired: $(this).prop('required'),
                        hadInitialValue: !!$(this).val()
                    });
                });

                // Track field completion on blur (when user leaves the field)
                $(formSelector + ' input.form-control').on('blur', function() {
                    const fieldId = $(this).attr('id');
                    const fieldName = $(this).attr('name');
                    const fieldValue = $(this).val().trim();
                    const hadValue = !!fieldValue;

                    window.DD_RUM.addAction('signup-field-blur', {
                        formType: formType,
                        fieldId: fieldId,
                        fieldName: fieldName,
                        categoryId: $('#category-id').val(),
                        isRequired: $(this).prop('required'),
                        isCompleted: hadValue,
                        valueLength: fieldValue.length
                    });
                });

                // Track remote checkbox interaction
                $('#service-remote').one('change', function() {
                    window.DD_RUM.addAction('signup-checkbox-interaction', {
                        formType: formType,
                        checkboxName: 'remote-service',
                        isChecked: $(this).is(':checked'),
                        categoryId: $('#category-id').val()
                    });
                });
            }
        }



        $(".prospect-signup-button").off('click.submit').on('click.submit', validateSignup);

        // For iOS, trigger the focus state on the input field
        $(".form-control-placeholder").on('click.focus', function () {
            if (Bark.isMobile()) {
                $(this).siblings('.form-control').eq(0).focus();
            }
        });

        // Project undo not interested action
        $('body').on('click', '.undo-not-interested-button', function (e) {
            Bark.showLoading();

            var data = {
                "recordType": 'prospect',
                "recordId": $("#prospect-id").val(),
                "projectId": $("#project-id").val(),
                "declineType": 99
            };

            $.ajax({
                type: "POST",
                url: "/response_declined_delete/",
                data: data,
                success: function (data) {
                    $(".not-interested-confirmation").fadeOut();
                    Bark.hideLoading();
                    $(".not-interested-link").removeClass('d-none').addClass('d-block');
                }
            });

            e.preventDefault();
            return false;
        });
    }

    /**
     * Checks to see if the supplied email address is in a valid format using basic validation.
     * @returns {boolean}
     */
    function emailIsValidFormat() {
        var email = $("#email").val();
        if (!email || !email.match(/.+@.+\..+/)) {
            return false;
        }
        return true;
    }

    /**
     * Logs a signup event
     * @param eventType The event type. One of: begin, click, validation_error, api_error, seller_exists, buyer_exists, lead_results, success
     * @param eventField If applicable, the related field
     * @param eventValue If applicable, the related field value
     */
    function logEvent(eventType, eventField, eventValue) {
        $.post(
            "/api/seller-signup-event-log/",
            {
                "signup_type": "prospect",
                "event_type": eventType,
                "event_field": eventField,
                "event_value": eventValue
            });
    }

    /**
     * Redirect to the seller page. This is done by scheduling a number of checks for leads, and redirecting based on those results.
     */
    function redirectToSellerPage () {
        const maxAttempts = 10;

        window.localStorage && window.localStorage.setItem && window.localStorage.setItem(`from_prospect_signup`, '1');

        try {
            // set up a request to run each second but starting with 0.5 seconds
            for (var seconds = 0.5; seconds <= maxAttempts; seconds++) {
                scheduleLeadCheck(seconds, (seconds === maxAttempts));
            }

            // After the other attempts have expired, assume no leads and redirect to the seller home
            redirectTimeouts.push(
                window.setTimeout(function () {
                    tracking('prospect-signup', 'Navigating to seller dashboard - rescue attempt', {
                        reason: 'no_leads',
                        attempt: maxAttempts + 1,
                        project_id: $('#project-id').val(),
                        prospect_id: $('#prospect-id').val(),
                        seller_profile_id: sellerProfileId,
                        is_user_rescue_flow,
                        is_lead_unavailable_flow,
                    });

                    logEvent("lead_results", "false", (maxAttempts + 1));
                    clearRedirectStorageKey();
                    location.href = '/sellers/dashboard/?noleads=1';
                }, (maxAttempts + 2) * 1000)
            );
        } catch(e) {
            // Some sort of error occurred, just redirect to the dashboard
            tracking('prospect-signup', 'Navigating to seller dashboard - rescue attempt', {
                reason: 'general_error',
                attempt: -1,
                project_id: $('#project-id').val(),
                prospect_id: $('#prospect-id').val(),
                seller_profile_id: sellerProfileId,
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });

            logEvent("general_error", "redirectToSellerPage", e.message);
            bugsnagClient.notify(e);
            clearRedirectStorageKey();
            location.href='/sellers/dashboard/';
        }
    }

    function getOrAssignExperiment(experimentName, projectId, prospectId) {
        return new Promise((resolve, reject) => {
            Bark.api(
                'user/experiments/get-or-assign',
                { experimentName, project_id: projectId, prospect_id: prospectId },
                (res) => resolve(res),
                (error) => reject(error),
                'POST'
            );
        });
    }

    /**
     * Schedules a check to see if any leads have been identified. If so, redirect to the leads dashboard and cancel all other checks
     * @param seconds The number of seconds to wait.
     */
    function scheduleLeadCheck(seconds, isFinalCheck) {
        redirectTimeouts.push(
            window.setTimeout(async function () {
                var handle,
                    projectId = $('#project-id').val();
                Bark.api(
                    'seller/barks',
                    {
                        is_prospect_response: 1,
                        project_id: projectId,
                        results_per_request: 1
                    },
                    async function (barks) {
                        // If they have any leads, take them to the lead dashboard, otherwise to the seller home dashboard
                        if (barks.data && barks.data.items && barks.data.items.length) {
                            // If they have a specific lead, wait to redirect to see if that actual lead came back.
                            // It may not come back on first check if the robot is still running
                            var isLeadFound = false;
                            if (projectId) {
                                for (var lead in barks.data.items) {
                                    if (barks.data.items[lead].project_id == projectId) {
                                        isLeadFound = true;
                                    }
                                }
                            }
                            // Ready to redirect if:
                            // 1) They did not sign up for a specific lead
                            // 2) They did sign up for a specific lead, and it has been matched to their account
                            // 3) This is the final time we are checking
                            if (!projectId || isLeadFound || isFinalCheck) {
                                while (handle = redirectTimeouts.pop()) {
                                    window.clearTimeout(handle);
                                }

                                tracking('prospect-signup', 'Navigating to seller dashboard', {
                                    attempt: seconds,
                                    project_id: $('#project-id').val(),
                                    prospect_id: $('#prospect-id').val(),
                                    seller_profile_id: sellerProfileId,
                                    is_user_rescue_flow,
                                    is_lead_unavailable_flow,
                                });

                                logEvent("lead_results", "true", seconds);
                                const hasQueryString = isProspectFindWorkPage() || isProspectDashboardPage();
                                const queryString = hasQueryString && isProspectFindWorkPage() ? 'new=pros-link' : 'new=pros-dashboard';
                                clearRedirectStorageKey();
                                
                                const sellerDashboardUrl = `/sellers/dashboard/${hasQueryString ? '?' : ''}${queryString}`;
                                location.href = sellerDashboardUrl;

                            } else {
                                while (handle = redirectTimeouts.pop()) {
                                    window.clearTimeout(handle);
                                }

                                tracking('prospect-signup', 'Navigating to seller dashboard - rescue attempt', {
                                    reason: 'no_leads',
                                    attempt: seconds,
                                    project_id: $('#project-id').val(),
                                    prospect_id: $('#prospect-id').val(),
                                    seller_profile_id: sellerProfileId,
                                    is_user_rescue_flow,
                                    is_lead_unavailable_flow,
                                });

                                clearRedirectStorageKey();
                                location.href = `/sellers/dashboard/?noleads=1`;
                            }
                        }
                    },
                    function (e) {
                        console.error(e);
                        logEvent("api_error", "scheduleLeadCheck", e.message);
                        bugsnagClient.notify(e);

                        tracking('prospect-signup', 'Navigating to seller dashboard - rescue attempt', {
                            reason: 'lead_check_error',
                            attempt: seconds,
                            project_id: $('#project-id').val(),
                            prospect_id: $('#prospect-id').val(),
                            seller_profile_id: sellerProfileId,
                            is_user_rescue_flow,
                            is_lead_unavailable_flow,
                        });

                        clearRedirectStorageKey();
                        location.href = '/sellers/dashboard/';
                    },
                    'GET',
                    Bark.apiVersionHeader('v2')
                );
            }, seconds * 1000)
        );
    }

    const setSellerProfileId = async () => {
        try {
            const response = await Bark.api('seller/self');
            sellerProfileId = response?.data?.spf_id;
        } catch (e) {
            tracking('prospect-signup', 'Failed to get seller profile id', {
                project_id: $('#project-id').val(),
                prospect_id: $('#prospect-id').val(),
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });
        }
    };

    const setRedirectStorageKey = () => {
        if (!window.localStorage) {
            return;
        }

        window.localStorage.setItem(redirectStorageKey, '1');
    };

    const clearRedirectStorageKey = () => {
        window.localStorage?.removeItem(redirectStorageKey);
    };

    window.addEventListener('storage', function (e) {
        if (e.key === redirectStorageKey && e.newValue === null) {
            // The poll key has been cleared
            window.setTimeout(() => {
                document.location = `/sellers/my-barks/?prx=${$("#project-id").val()}`;
            }, 5000);
        }
    });

    const existingUserRescueFlow = () => {
        const modal = $('#user-exists-in-system-modal');
        modal.modal('show');

        setRedirectStorageKey();

        $('.js-user-exists-retry-submit', modal).off('click.retry').on('click.retry', () => {
            modal.modal('hide');

            tracking('prospect-signup', 'Existing user rescue flow - retry submit', {
                project_id: $('#project-id').val(),
                prospect_id: $('#prospect-id').val(),
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });

            validateSignup();
        });

        tracking('prospect-signup', 'Existing user rescue flow - show modal', {
            project_id: $('#project-id').val(),
            prospect_id: $('#prospect-id').val(),
            is_user_rescue_flow,
            is_lead_unavailable_flow,
        });

        try {
            $(modal.data('bs.modal')._backdrop).css({backgroundColor: 'rgb(17, 22, 55)'})
        } catch (e) {}
    };

    async function submitSignup() {

        try {
            payload.captchaToken = await getRecaptchaToken('seller_prospect_signup');
            payload.platform = 'web';
        } catch (e) {
            console.error('Error getting reCAPTCHA token:', e);
            return false;
        };

        Bark.json({
            url: '/sellers/save-new-account/',
            data: {payload: JSON.stringify(payload)}
        }).done(async function (e) {
            if (e.result === 'OK') {
                try {
                    // Store the login token
                    logEvent("success", "", "");

                    tracking('prospect-signup', 'Enter details - success', {
											category_id: payload.maincategoryid ?? $('#category-id').val(),
											project_id: $('#project-id').val(),
											is_user_rescue_flow,
											is_lead_unavailable_flow,
										});
										tracking('prospect-signup', 'Signup - success', {
											project_id: $('#project-id').val(),
											category_id: payload.maincategoryid ?? $('#category-id').val(),
											is_user_rescue_flow,
											is_lead_unavailable_flow,
										});

                    window.Bark.ENV.JWT = e.data.jwt;

                    await setSellerProfileId();

                    // Start a process to determine the correct page to redirect to
                    redirectToSellerPage();
                    return;
                } catch(e) {
                    // Some sort of error occurred, just redirect to the dashboard
                    logEvent("general_error", "submitSignup", e.message);
                    bugsnagClient.notify(e);

                    tracking('prospect-signup', 'Navigating to seller dashboard - rescue attempt', {
                        reason: 'general_error',
                        attempt: -1,
                        project_id: $('#project-id').val(),
                        prospect_id: $('#prospect-id').val(),
                        seller_profile_id: sellerProfileId,
                        is_user_rescue_flow,
                        is_lead_unavailable_flow,
                    });

                    clearRedirectStorageKey();

                    location.href='/sellers/dashboard/';
                }
                return;
            } else if (e.errcode === Bark.consts.EX_EMAIL_EXISTS_IN_SELLERS) {
                tracking('prospect-signup', 'Error saving account', {
                    reason: 'email_exists_in_sellers',
                    project_id: $('#project-id').val(),
                    prospect_id: $('#prospect-id').val(),
                    is_user_rescue_flow,
                    is_lead_unavailable_flow,
                });

                Bark.hideLoading();
                unblockSubmit();
                $("#prospectSignupFormModal").modal('hide');

                logEvent("seller_exists", "email", $("#email").val());
                existingUserRescueFlow();
                return;
           } else if (e.errcode === Bark.consts.EX_EMAIL_EXISTS_IN_BUYERS) {
                tracking('prospect-signup', 'Error saving account', {
                    reason: 'email_exists_in_buyers',
                    project_id: $('#project-id').val(),
                    prospect_id: $('#prospect-id').val(),
                    is_user_rescue_flow,
                    is_lead_unavailable_flow,
                });

                Bark.hideLoading();
                unblockSubmit();
                $("#prospectSignupFormModal").modal('hide');

                logEvent("buyer_exists", "email", $("#email").val());
                existingUserRescueFlow();
                return;
            } else if (e.data.code == 400) {
                tracking('prospect-signup', 'Error saving account', {
                    reason: 'general_error',
                    project_id: $('#project-id').val(),
                    prospect_id: $('#prospect-id').val(),
                    is_user_rescue_flow,
                    is_lead_unavailable_flow,
                });

                Bark.hideLoading();
                unblockSubmit();
                $("#prospectSignupFormModal").modal('show');
                $("#name").addClass('is-invalid');
                return;
            } else if (e.data.code == 422) {
                Bark.hideLoading();
                unblockSubmit();
                if ($('#phone').length && e.errcode === Bark.consts.PHONE_NUMBER_DOES_NOT_BELONG_TO_COUNTRY) {
                    showPhoneError(e.result);
                    return;
                }
                Bark.alertModal(e.result, _t('public_prospects-signup:close-header'));
                return;
            }
            Bark.hideLoading();
            Bark.alertModal(e.result, _t('public_prospects-signup:close-header'));
            unblockSubmit();
        }).fail(function () {
            tracking('prospect-signup', 'Error saving account', {
                reason: 'general_error',
                project_id: $('#project-id').val(),
                prospect_id: $('#prospect-id').val(),
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });

            Bark.hideLoading();
            $("#prospectSignupFormModal").modal('hide');
            unblockSubmit();
            Bark.alertModal(_t('public_prospects-signup:error-saving-account'), _t('public_prospects-signup:close-header'));
        });

    }

    /**
     * Validates the phone number. If not required and empty, moves to the next step and submits signup.
     * If required and empty, blocks submission with an inline error. Otherwise validates the supplied number.
     * @returns {boolean}
     */
    function validatePhone() {
        if (!userdata.tel) {
            if (!isPhoneRequired()) {
                submitSignup();
                return;
            }

            unblockSubmit();
            Bark.hideLoading();
            showPhoneError(_t('public_prospects-signup:phone-required-message'));
            return;
        }

        Bark.validate.telephone(userdata.tel, function (responseObject) {
            if (responseObject.status) {
                userdata.phone_type = responseObject.lineType;
                submitSignup();
            } else {
                unblockSubmit();

                showPhoneError(_t('public_prospects-signup:phone-validation-message'));
                logEvent("validation_error", "telephone_external", userdata.tel);
                Bark.hideLoading();
            }
        }, true);
    }

    /**
     * Check name fields to make sure they dont contain any contact info.
     * If passes, moves on to final form submission
     */
    function validateCompanyName()
    {
        return new Promise(function(resolve, reject) {
            Bark.api(
                '/contentfilter/contactdetails',
                {
                    'contents': {
                        'company-name': userdata.companyname,
                        'name': userdata.name
                    }
                },
                function(data) {
                    if (data.status) {
                        resolve();
                    } else {
                        let failed = data.failures;
                        for (var i=0; i< failed.length; i++) {
                            var fieldname = failed[i];
                            var el = $('#' +fieldname);
                            el.addClass('is-invalid');
                            $('#'+fieldname+'-row-error').text(_t('public_prospects-signup:no-contact-details'));
                            logEvent("validation_error", fieldname);
                            Bark.addErrorAnimation($("#"+fieldname), true);
                        }
                        unblockSubmit();
                        reject(new Error('Company name validation failed'));
                    }
                },
                function(error) {
                    window.bugsnagClient.notify(error);
                    // On API error, resolve to continue with submission (existing behavior)
                    resolve();
                },
                'POST',
                Bark.apiVersionHeader('v1')
            );
        });
    }

    function blockSubmit() {
        $('.prospect-signup-button').attr('disabled', true).html(
            '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> '+_t('common:loading-message')
        );
    }

    function unblockSubmit() {
        $('.prospect-signup-button').attr('disabled',false).html(_t('public_prospects-signup:continue-button'));
    }

    function isPhoneRequired() {
        return $('#phone').is('[required]');
    }

    function showPhoneError(message) {
        $('#phone').addClass('is-invalid');
        $('#phone-row-error').text(message).removeClass('d-none');
        Bark.addErrorAnimation($('#phone'), true);
    }

    /**
     * Validates the signup form, and proceeds towards submission if valid.
     * @param e
     * @returns {boolean}
     */
    function validateSignup(e) {
        // Track button click for signup-v4 page
        if ($('.prospect-signup-features').length > 0) {
            tracking('Prospects - Signup', 'Enter Details New - Click View NAME\'s details', {
                category_id: payload.maincategoryid ?? $('#category-id').val(),
                country_id: $('#country-id').val(),
                project_id: $('#project-id').val(),
            });
        }

        // Track with Datadog RUM for both signup forms
        if (typeof window.DD_RUM !== 'undefined') {
            const isV4Form = $('.prospect-profile-form-v4').length > 0;
            const isV3Form = $('.prospect-profile-form').length > 0;

            if (isV4Form || isV3Form) {
                const formType = isV4Form ? 'signup-v4' : 'signup-v3';
                const actionName = isV4Form ? 'continue-button-v4-click' : 'continue-button-click';
                const hasCompanyName = !!$('#company-name').val();
                const hasWebsite = !!$('#website').val();
                const isRemoteChecked = $('#service-remote').is(':checked') || $('#service-nationwide').val() === "1";
                const buyerName = $('.prospect-signup-button').text().includes('View') || $('.prospect-signup-button').text().includes('details');

                window.DD_RUM.addAction(actionName, {
                    formType: formType,
                    userStatus: $('#email').length ? 'anonymous' : 'logged-in',
                    hasBuyer: buyerName,
                    isRemote: isRemoteChecked,
                    categoryId: $('#category-id').val(),
                    countryId: $('#country-id').val(),
                    projectId: $('#project-id').val(),
                    hasCompanyName: hasCompanyName,
                    hasWebsite: hasWebsite,
                    cityName: $('#city-name').val()
                });
            }
        }

        $(".is-invalid").removeClass('is-invalid');
        $(".invalid-feedback").removeClass('d-none');
        const emailField = $('#email');

        userdata = {
            companyname: $('#company-name').val(),
            email: emailField.length ? emailField.val() : undefined,
            tel: $('#phone').val(),
            website: $('#website').val(),
            prospect_id: $('#prospect-id').val(),
            name: $('#name').val().trim(),
        };

        var invalidFields = [];

        if (!userdata.name || userdata.name.length < 2) {
            invalidFields.push('name');
            logEvent("validation_error", "name", userdata.name);
            Bark.addErrorAnimation($("#name"), true);
        }

        if (emailField.length && (!userdata.email || !emailIsValidFormat())) {
            invalidFields.push('email');
            logEvent("validation_error", "email_local", userdata.email);
            Bark.addErrorAnimation($("#email"), true);
            $("#email-row-error").html(_t('public_prospects-signup:email-validation-message'));
        }

        // Basic website validation
        if (userdata.website) {
            if (!userdata.website.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)) {
                $("#website").addClass('is-invalid');
                $('#website-row-error').text(_t('public_prospects-signup:web-address-validation-message')).removeClass('d-none');
                Bark.addErrorAnimation($('#website'), true);
                logEvent("validation_error", "website", userdata.website);
                invalidFields.push('website');
            }
        }

        // Basic phone validation
        if (isPhoneRequired() && !userdata.tel) {
            logEvent("validation_error", "telephone_required", "");
            invalidFields.push('phone');
            $('#phone-row-error').text(_t('public_prospects-signup:phone-required-message'));
            Bark.addErrorAnimation($("#phone"), true);
        } else if (userdata.tel) {
            var teltest = window.basicPhoneCheck.test(userdata.tel);
            if (teltest.invalid || teltest.badChars) {
                logEvent("validation_error", "telephone_local", userdata.tel);
                invalidFields.push('phone');
                $('#phone-row-error').text(_t('public_prospects-signup:phone-validation-message'));
                Bark.addErrorAnimation($("#phone"), true);
            }
        }

        if (invalidFields.length) {
            Bark.hideLoading();
            for (var index in invalidFields) {
                var field = invalidFields[index]
                $("#" + field).addClass('is-invalid');
                $("#" + field + "-row-error").removeClass('d-none');
            }
            Bark.hideLoading();
            return false;
        }

        var remote = "0";
        if ($("#service-remote").is(':checked')) {
            remote = "1";
        }
        else if ($("#service-nationwide").val() == "1") {
            remote = "1";
        }

        const cityId = $('#city-id').val();

        payload = {
            maincategoryid: $('#category-id').val(),
            countryId: $('#country-id').val() || undefined,
            othercategories: $('#category-ids').val() ? $('#category-ids').val().split(',') : '',
            userdata: userdata,
            location: {
                city_type: 'c',
                id: $('#city-id').val(),
                lat: $('#latitude').val(),
                lng: $('#longitude').val(),
                name: $('#city-name').val(),
                radius: undefined, // This will be calculated in the signup process
                shapes: undefined,
                subtype: undefined,
                type: cityId ? 'radius' : 'nationwide',
                value: undefined,
                remote: remote
            },
            business_log: {
                business_id: null,
                prospect_id: $('#prospect-id').val(),
                project_id: $('#project-id').val(),
            }
        }

        // Check the email address with Mailgun
        blockSubmit();

        if (emailField.length) {
            // Start both email and company name validation in parallel
            var emailValidationPromise = new Promise(function(resolve, reject) {
                emailField.email_validator({
                    success: function (data) {
                        if (data.is_valid) {
                            resolve();
                        } else {
                            unblockSubmit();
                            $('.prospect-signup-button').attr('disabled', false).html('Continue');
        
                            var emailErrorMsg = _t('public_prospects-signup:email-validation-message');
        
                            if (data.did_you_mean) {
                                emailErrorMsg = _t(
                                    'public_prospects-signup:did-you-mean-message',
                                    {
                                        did_you_mean_link: Bark.sprintf('<a href="#" className="email-did-you-mean">%s</a>', data.did_you_mean),
                                        interpolation: {escapeValue: false}
                                    }
                                );
                                logEvent("validation_error", "email_external_suggestion", $("#email").val());
                            } else {
                                logEvent("validation_error", "email_external", $("#email").val());
                            }
        
                            $('#email-row-error').html(emailErrorMsg).removeClass('d-none');
                            $("#email").addClass('is-invalid');
        
                            if (data.did_you_mean) {
                                $('.email-did-you-mean').off('click').on('click', function (e) {
                                    logEvent("suggestion_accepted", $("#email").val(), data.did_you_mean);
                                    $('#email').val(data.did_you_mean);
                                    $('#email-row-error').addClass('d-none');
                                    $("#email").removeClass('is-invalid');
                                    e.preventDefault();
                                    return false;
                                });
                            }
        
                            Bark.addErrorAnimation($('#email'), true);
                            Bark.hideLoading();
                            reject(new Error('Email validation failed'));
                        }
                    },
                    error: function () {
                        unblockSubmit();
                        var emailErrorMsg = _t('public_prospects-signup:email-validation-message');
        
                        $('#email-row-error').html(emailErrorMsg).removeClass('d-none');
                        $("#email").addClass('is-invalid');
        
                        Bark.addErrorAnimation($('#email'), true);
                        Bark.hideLoading();
                        logEvent("validation_error", "email_external", $("#email").val());
                        reject(new Error('Email validation error'));
                    }
                });
            });
        
            var companyNameValidationPromise = validateCompanyName();
        
            // Wait for both validations to complete
            Promise.all([emailValidationPromise, companyNameValidationPromise])
                .then(function() {
                    // Both validations succeeded, proceed to phone validation
                    validatePhone();
                })
                .catch(function (error) {
                    if (typeof window.DD_RUM !== 'undefined') {
                        window.DD_RUM.addError(error, {
                            context: 'prospect-signup-validation',
                            validationType: 'email-or-company-name',
                        });
                    }
                });
        } else {
            // There is a logged-in user here so there isn't an email field to validate
            // Still validate company name, then proceed to phone validation
            validateCompanyName()
                .then(function() {
                    validatePhone();
                })
                .catch(function(error) {
                    // Error handling is done in validateCompanyName
                });
        }
    }

    const autoSubmitIfRequired = () => {
        const params = new URLSearchParams(location.search);

        if (!params.has('aus')) {
            return;
        }

        params.delete('aus');
        window.history?.replaceState(null, null, `?${params.toString()}`);

        tracking('prospect-signup', 'Existing user rescue flow - auto-submit', {
            project_id: $('#project-id').val(),
            prospect_id: $('#prospect-id').val(),
            is_user_rescue_flow,
            is_lead_unavailable_flow,
        });

        validateSignup();
    };

    const showErrorModalIfRedirect = () => {
        const params = new URLSearchParams(location.search);

        if (!params.has('bn')) {
            return;
        }

        is_lead_unavailable_flow = 1;

        const buyerName = decodeURIComponent(params.get('bn'));
        const modal = $('#lead-no-longer-available-modal');
        params.delete('bn');

        window.history?.replaceState(null, null, `?${params.toString()}`);

        $('.js-unavailable-modal-title', modal).text(
            _t('public_prospects-signup:lead-no-longer-available.title', { buyer_public_name: buyerName })
        );

        $('.js-unavailable-modal-subtitle', modal).text(
            _t('public_prospects-signup:lead-no-longer-available.subtitle', { buyer_public_name: buyerName })
        );

        $('.js-unavailable-modal-confirm', modal).off('click.confirm').on('click.confirm', () => {
            tracking('prospect-signup', 'Redirect Alert - Confirm', {
                project_id: $('#project-id').val(),
                prospect_id: $('#prospect-id').val(),
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });
            modal.modal('hide');
            $(".prospect-signup-form-link").click();
        });

        $('.js-unavailable-modal-cancel', modal).off('click.cancel').on('click.cancel', () => {
            tracking('prospect-signup', 'Redirect Alert - Close', {
                project_id: $('#project-id').val(),
                prospect_id: $('#prospect-id').val(),
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });
        });

        modal.modal('show');

        try {
            $(modal.data('bs.modal')._backdrop).css({backgroundColor: 'rgb(17, 22, 55)'})
        } catch (e) {}
    };

    $(document).ready(function () {
        is_user_rescue_flow = Number($('#user-rescue-flow').val()) === 1;
        attachEventHandlers();
        logEvent("begin");
        showErrorModalIfRedirect();

        tracking('prospect-signup', 'Start prospect sign-up', {
					project_id: $('#project-id').val(),
					category_id: payload.maincategoryid ?? $('#category-id').val(),
					is_user_rescue_flow,
					is_lead_unavailable_flow,
				});

        if ($('.prospect-dashboard-signup-form-container').length > 0) {
            tracking('prospect-signup', 'Enter details - view', {
							category_id: payload.maincategoryid ?? $('#category-id').val(),
							project_id: $('#project-id').val(),
							is_user_rescue_flow,
							is_lead_unavailable_flow,
						});
        } else if ($('.prospect-leads-list-bk').length > 0) {
            tracking('prospect-signup', 'Select free lead - view', {
                category_id: payload.maincategoryid ?? $('#category-id').val(),
                project_id: $('#project-id').val(),
                is_user_rescue_flow,
                is_lead_unavailable_flow,
            });
        }

        // Track page view for signup-v4 page
        if ($('.prospect-signup-features').length > 0) {
            tracking('Prospects - Signup', 'Enter Details New - Page Viewed', {
                category_id: payload.maincategoryid ?? $('#category-id').val(),
                country_id: $('#country-id').val(),
                project_id: $('#project-id').val(),
            });
        }

        autoSubmitIfRequired();
    });
}
